import { render, staticRenderFns } from "./EventSponsorBanner.vue?vue&type=template&id=b6d42380&scoped=true&"
import script from "./EventSponsorBanner.vue?vue&type=script&lang=js&"
export * from "./EventSponsorBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d42380",
  null
  
)

export default component.exports